import type { IconComponent } from '@fs/zion-icon'
import { ControlDashboard, DocumentRecordSearch, HelpTip, ThingBeaker } from '@fs/zion-icon'

export interface Tool {
  id: string
  primaryText: string
  secondaryText: string
  to: string
  Icon: IconComponent
  /** Prose shown under the tool page's H1 by PageHeader. */
  pageDescription?: string
}

export interface ToolSection {
  heading: string
  toolIds: ToolId[]
}

// Single source of truth for the portal's tools: the home page cards and the header nav are both built from it.
export const TOOLS = {
  webToIndex: {
    id: 'webToIndex',
    primaryText: 'Web to Index',
    secondaryText: 'Convert a web page to a structured index',
    pageDescription: 'Enter a website URL to crawl it, run predictions, and produce GEDCOM X and MOBS output.',
    to: '/web-to-index',
    Icon: DocumentRecordSearch,
  },
  agentChatDemo: {
    id: 'agentChatDemo',
    primaryText: 'Agent Chat Demo',
    secondaryText: 'Demo for Agent Chat',
    to: '/agent-chat-demo',
    Icon: ThingBeaker,
  },
  aiAssistant: {
    id: 'aiAssistant',
    primaryText: 'AI Assistant',
    secondaryText: 'Labs Landing Page for AI Assistant',
    to: '/aiassistant/chat',
    Icon: HelpTip,
  },
  dashboard: {
    id: 'dashboard',
    primaryText: 'Dashboard',
    secondaryText: 'Ordinance-ready names at a glance',
    pageDescription:
      'How many names are marked ready for temple ordinances, and what the rest are still missing. Published daily by the ATC pipeline.',
    to: '/dashboard',
    Icon: ControlDashboard,
  },
} satisfies Record<string, Tool>

export type ToolId = keyof typeof TOOLS

export const SECTIONS: ToolSection[] = [
  { heading: 'Reports', toolIds: ['dashboard'] },
  { heading: 'Data Extraction', toolIds: ['webToIndex'] },
  { heading: 'AI Assistants', toolIds: ['agentChatDemo', 'aiAssistant'] },
]
